import styled from 'styled-components'
import { Wrapper as ImageWrapper } from '../postImage/postImage.styles'

export const Wrapper = styled(ImageWrapper)`
  &::before {
    content: '';
    background: rgba(0, 0, 0, 0.15);
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }
`

Wrapper.displayName = 'Wrapper'

export const LiveBadge = styled.div`
  min-width: 5.875rem;
  height: 2.1875rem;
  right: 3.125rem;
  bottom: 3.125rem;
  z-index: 2;

  svg {
    width: 1.25rem;
    height: 1.25rem;
  }
`

LiveBadge.displayName = 'LiveBadge'

type ImageProps = {
  fullWidth?: boolean
}

export const Image = styled.img<ImageProps>`
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  height: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  object-fit: cover;
`

Image.displayName = 'Image'
